module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Readed-mail-f4e1c29745c091743fb5b5a3551c2261.svg";